module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-347b01c2.png";